import { render, staticRenderFns } from "./details.vue?vue&type=template&id=b63098de&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=b63098de&prod&lang=less"
import style1 from "./details.vue?vue&type=style&index=1&id=b63098de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63098de",
  null
  
)

export default component.exports